import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { useFormikContext } from 'formik';
import { Button } from "@mui/material";




const SignatureField = ({ name, width = 500, height = 200, ...props }) => {
    const { setFieldValue, values, errors, touched, setFieldTouched } = useFormikContext();
    const sigPad = useRef(null);

    // When the user lifts the pen/finger, grab the image
    const handleEnd = () => {
        const dataURL = sigPad.current
            .getTrimmedCanvas()
            .toDataURL('image/png');
        setFieldValue(name, dataURL);
        setFieldTouched(name, true, true);
    };

    // Clear both pad and form value
    const handleClear = () => {
        sigPad.current.clear();
        setFieldValue(name, '');
    };

    return (
        <div>
            <div>
                <SignatureCanvas
                    ref={sigPad}
                    penColor="black"
                    canvasProps={{
                        width,
                        height,
                        className: 'signature-canvas',
                        style: { border: '1px solid #ccc', borderRadius: 4 }
                    }}
                    onEnd={handleEnd}
                    {...props}
                />
            </div>
            <Button
                 fullWidth="500px"
                type="button"
                variant="contained"
                color="secondary"
                onClick={handleClear}
            >
                Clear
            </Button>

            {touched[name] && errors[name] && (
                <div style={{ color: 'red', marginTop: 4 }}>
                    {errors[name]}
                </div>
            )}

            {/* Optional preview
            {values[name] && (
                <img
                    src={values[name]}
                    alt="Signature preview"
                    style={{ display: 'block', marginTop: 8, maxWidth: width }}
                />
            )} */}
        </div>
    );
};

export default SignatureField;
